import React, { forwardRef } from 'react';

/**
 * `Box` is a functional React component that accepts a set of properties and returns a new component with those properties.
 * It is designed to prevent unnecessary updates by flattening the `style` prop.
 *
 * @component
 * @param {Object} props - The properties passed to the component.
 * @param {React.ElementType} [props.Component='div'] - The type of component to render. Defaults to 'div'.
 * @param {string} props.className - The CSS class to apply to the component.
 * @param {React.ReactNode} props.children - The child elements to render within the component.
 * @param {Object} props.componentProps - The properties passed to the component.
 * @param {Object} props.style - The style properties to apply to the component.
 * @returns {React.Element} A React element of the specified component type with the given properties.
 */
export const Box = forwardRef(({
  Component = 'div', className, children, componentProps, ...style
}, ref) => <Component ref={ref} className={className} style={style} {...componentProps}>{children}</Component>);
